<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ph">I</h2>
<p class="calibre11">They were parked on the dark side of Mercury, snug and comfortable in
their hemisphere of force that kept out the cold and kept in the air.
At one side where force met ground, a tall silvery spacecraft rose like
a chimney.</p>
<p class="calibre11">They were three:</p>
<p class="calibre11">Chat Honger was tall, red-headed, and thin faced. He looked as though
he were incapable of quieting down, but he was really the type of
person who has an incredible amount of patience for things which cannot
be performed in a hurry.</p>
<p class="calibre11">Bren Fallow was shorter than Chat Honger, darker, stouter, more round
of face and more amiable. Definitely, Bren was the methodical type.</p>
<p class="calibre11">The third man was Scyth Radnor. Scyth was the kind of man who is quick
to grasp a new idea and as quick to reduce it to practise. His failing
was that he seldom looked deep or planned far ahead. Being quick of
mind he preferred to play everything by ear because planning required
study, and Scyth felt that study for the sake of study consumed too
much time—time that could better be spent in the pursuit of fun and
games.</p>
<p class="calibre11">Teach them the language and drop them in Greater New York and they
would be lost among Manhattan's millions. Better change their clothing,
though. Striped shorts, Greek sandals, a Sam Browne belt across a bare
chest, and a Roman toga of iridescent changing hues is not the kind of
costume seen on Fifth Avenue.</p>
<p class="calibre11">Aside from their costume they were human to the last detail. Even their
speech, when translated, sounded like the human tongue. They used
slang, elision, swearwords and poor grammar. They made bum jokes and
puns. They sounded more like displaced earthmen than technicians from a
culture that had been establishing galactic centers of population for
thirty thousand years.</p>
<p class="calibre11">"You're certain?" asked Bren.</p>
<p class="calibre11">Scyth nodded. "Dead certain now. It was that last computation that sold
me."</p>
<p class="calibre11">"Then I'd better shut down."</p>
<p class="calibre11">Chat Honger shook his head. "We've got a job to do. We're behind
schedule now, fellows, because of this question. We've got a beacon to
start here, I say let's get along with it and bedamned to the—"</p>
<p class="calibre11">"You can't," said Bren. "The first time you put down in the log that
this is a middle sequence flare-star, right smack-dab in the middle of
Yalt Gangrow's Diagram, the Bureau of Colonization is going to ask you
if you took a look for habitable planets. Then—then what, Scyth?"</p>
<p class="calibre11">Scyth Radnor shrugged. "The answer is 'yes' we took a look and we
found one, just at the right distance, the right size, and the right
conditioning. To say nothing of upper atmosphere and other data made by
observation. So Planet Three is about as habitable as Marandis itself."</p>
<p class="calibre11">Chat grunted. "Looked for any signs of life?"</p>
<p class="calibre11">Scyth nodded. "The phanobands are as dead as you-know-what. The
machinus fields are all as dead as one might expect this far from
any established route. There are a few bits and dabs of stuff on the
radiomagnetic spectrum which show a recurrent pattern too fast to be
anything of natural phenomena, however. I say we ought to take a look."</p>
<p class="calibre11">Chat shook his head slowly. "I didn't expect to find it inhabited. But
even knowing it is habitable is—"</p>
<p class="calibre11">Bren said, "If mere habitability is all you're after we can go ahead
and establish our beacon and leave Planet Three to be handled later. A
beacon wouldn't ruin the planet itself, you know."</p>
<p class="calibre11">Scyth said, "We'd better take a look-see anyhow. That last computation
on the radiomagnetic stuff looked too much like man-made radiation to
me."</p>
<p class="calibre11">Bren Hallow smiled. "Look," he said slowly, "If this planet is
inhabited, how come the Bureau of Colonization doesn't know about it.
Not one case in the history of Marandis shows the discovery of an
inhabited planet that—"</p>
<p class="calibre11">Chat interrupted, sourly, "that didn't stem from Marandanian origin.
But how about the several cases of spacewreck? Look what we're doing.
We're setting up beacons along a rift through the galaxy from Marandis
to the Spiral Cluster. We found this rift after years of hard work
and galactic surveying and exploring, and both of you know just how
fabulous it is. Well, suppose someone found it twenty thousand years
ago and got marooned?"</p>
<p class="calibre11">"So what do we do? Take a run to Planet Three and radiate machinus
fields all over space? Not until we know. So, Scyth, can you ducky us
up a high-sensitivity job out of one of the standard menslators?"</p>
<p class="calibre11">"I think so. D'you think it will work?"</p>
<p class="calibre11">"If there is a primitive culture of the most low-grade organization
there, there will also be one or more leading characters. A man of fame
or power—or infame and power—whose person will be in the active minds
of a large number of hypothetical inhabitants. We should be able to
get some sort of response even if the whole thing is primitive as all
get-out. But let's take a look before we do anything that's likely to
get us into trouble. We're late now, another few hours isn't going to
hurt much more."</p>
<p class="calibre11">The discussion in the dome on Mercury's dark side abated as the trio
went to work. Scyth began to tinker with his menslators; Chat began
to prowl the confines like a caged animal, thinking deeply, and Bren
Hallow went back to his massive equipment that was designed to create a
galactic beacon.</p>
<p class="calibre11">On this Third Planet of Sol there were still captains and kings and
presidents and commissars and a couple of dictators and a new invention
or two, all of which professed to be gentle guardians of the public
rights. Only the names had changed, some in violence and some in peace.
The names of places were about the same; a few had disappeared in the
heat of ideology, but by and large things and people persisted despite
atoms, politics and the cussedness of human nature. Youth was still
going to hell—and old age was still fuddy-duddy.</p>
<p class="calibre11">One apparent change might have been noticed by a man of the middle of
the century, and even he would have expected it.</p>
<p class="calibre11">The history of this change reads like this:</p>
<p class="calibre11">A few years after Global War I, the manufacturer of a breakfast food
product known as "Oatflakes" realized a rather monumental increase in
the sale of his product. Conscientious investigation showed that this
increase was not due to the public becoming addicted to oatmeal as a
morning, noon and night diet (with a midnight snack tossed in) but
entirely due to a new plaything called the "Wireless." Wireless, it was
found, required as a major component about a quarter of a mile of wire
wound around the cylindrical box in which the oatflakes were packed.</p>
<p class="calibre11">Some years later, when the first home-manufacture of radio sets slowed
because of professional manufacture of commercial radio, the sale of
Oatflakes dropped to normal. At this point the manufacturer of the
food product realized that the pathway to high sales was not along the
contents, but along the package. Let the public buy the stuff for the
box, or the box-top. If he wants to eat the stuff on the inside, that's
his business!</p>
<p class="calibre11">So in the early-middle years of the century there arose a character
called Hopalong Cassidy, who portrayed an Old West chivalry and heroic
strength great enough to sell boxtops by the gross ton. He tied-in
sales with toy and clothing makers until business reached the Law of
Diminishing Returns. After selling spurs for roller skates the brains
ran out of ideas and turned to new fields.</p>
<p class="calibre11">Space travel was the coming thing, so the youth of the land turned to
Tom Corbett, Space Cadet.</p>
<p class="calibre11">Tom Corbett's only trouble was the same as the difficulty encountered
by one Frank Merriwell fifty years earlier. After twenty years, Tom
Corbett became the oldest undergraduate in Space Academy, just as
Merriwell became the oldest undergraduate at Yale. The youth of the
race wanted a real spaceman, full fledged and heroic, and so they got
it.</p>
<p class="calibre11">Meet Dusty Britton of The Space Patrol....</p>
<p class="calibre11">The sleek spacecraft landed and the clouds of hot dust rose almost to
the spacelock, driven up by the fierce reaction blast. A hundred yards
from the Patrol cruiser lay the broken spacecraft of Roger Fulton,
arch-fiend, cornered at last.</p>
<p class="calibre11">The spacelock opened and Dusty Britton looked out through a wisp of
the deadly radioactive dust. He was clad in the uniform of The Space
Patrol: black breeches and dark blue whipcord shirt piped in gold.
Calf-length black polished boots. His head was bare, and the collar
of his dress shirt was open wide enough to show the fine muscles of
his upper chest and shoulders. He was blondish with a wide open face
of the type that is associated with laughing-at-danger. His physique
was almost marvelous, slender-waisted, broad-shouldered, long-legged,
and agile-armed. His arms and hands and face were tanned from the
radiations of Outer Space and there were the million little wrinkles
about his eyes that were natural, not because of age, but because of
the price one pays for being a Spaceman. At his hip swung the secret
sidearm of The Space Patrol, a raygun far more deadly than the Colt .45
in the hands of him who knew its use.</p>
<p class="calibre11">Dusty Britton took a step forward to the edge of the spacelock,
took a deep breath, and then jumped down into the floating cloud of
radioactive dust kicked up by the landing blast. Within seconds he was
out of the cloud again and racing across the ground to the ship of
Roger Fulton which had landed askew.</p>
<p class="calibre11">His crew appeared in the spacelock and looked down, not daring to drop
into that horror, knowing that they were not as fast as Dusty Britton
and could not make it through in time to be safe.</p>
<p class="calibre11">Across to the wrecked spacer he went, boldly breaching the ruined
spacelock. Along the corridor he went warily until he came to the
control room. He kicked the door open and walked in, poised lightly on
the balls of his feet, lithe and ready to spring like a stalking cat.</p>
<p class="calibre11">Then Dusty Britton faced his arch-enemy, Roger Fulton. Roger Fulton
wore a three-day beard, his clothing was stained and torn and his hair
unkempt. Fulton watched Britton with cold, angry eyes.</p>
<p class="calibre11">"Now," said Dusty Britton harshly, "Let's have it, Roger!"</p>
<p class="calibre11">Very slowly and very carefully, Roger Fulton's hands found the buckle
of his blaster-belt and unfastened it. He let it drop, putting out a
leg so that belt and blaster slid easily to the floor. As it reached
his toe, Roger Fulton kicked it to one side. He shook his head and
sneered at Dusty Britton.</p>
<p class="calibre11">"I should draw and fight the fastest man in The Space Patrol?" sneered
Roger Fulton. "I surrender. You'll never blast an unarmed man, Britton!"</p>
<p class="calibre11">Dusty tossed his head. Keeping one eye on Roger Fulton, Dusty sidled
across the control room to where Barbara Crandall was tied to a chair.
Her eyes were soft for Dusty as he stripped the gag from her mouth and
untied her bonds with his left hand. She sat up, rubbing her wrists and
working her mouth, trying to tell Dusty something important that would
not come through the cramped muscles.</p>
<p class="calibre11">Dusty turned to Roger Fulton. "I've waited for this moment," he said.
Quickly he unbuckled his own blaster and tossed it aside. Then he
stalked forward, poised to strike, his hands opening and closing at his
sides. "Man to man, Fulton. That is, if there's enough man in you to
fight!"</p>
<p class="calibre11">Roger Fulton crowed, "Sucker!" and went into whirlwind action. His hand
darted inside his shirt and came out with a tiny miniblast.</p>
<p class="calibre11">There came the throbbing sound of raw energy and a flash that blinded.
Yellowish smoke curled out and surrounded the scene. Barbara Crandall
screamed and tried to get to her feet but the hours of being tied had
numbed her muscles and she fell back into her chair helplessly. The
yellowish cloud billowed higher in the control room and began to thin.</p>
<p class="calibre11">Then out of the cloud walked Dusty Britton. He held his right hand by
the wrist, shaking it with his left. "Stunned a bit," he smiled bravely.</p>
<p class="calibre11">"But how—?"</p>
<p class="calibre11">Dusty opened the fingers of his right hand and let a miniblast fall
to the floor, its charge gone, its usefulness ended. "He tried the
old hidden-gun trick," said Dusty. "But two can play that game. Roger
Fulton will never menace honest spacemen again!"</p>
<p class="calibre11">The music swelled as the scene faded out; a cheer from Dusty's crew
finished off one more opus of Dusty Britton and The Space Patrol.</p>
<p class="calibre11">It was a special occasion, this showing. It was Noon in New Mexico,
but the showing had gone out across a worldwide instantaneous network
no matter what time it was at the receiving end. In some places it was
late in the morning, in some places early, others had this showing late
at night. But people were watching back and forth across the face of
the Earth.</p>
<p class="calibre11">The film came to end, there was the white flash, then an intermittent
flicker as cross-country synchronization took hold. (This flicker was
done with an eye toward the dramatic; worldwide networks could latch in
without a wink of the screen anywhere in the world.) An announcer came
on with the statement that everybody had been waiting for:</p>
<p class="calibre11">"And now we take you to Dusty Britton in person, from White Sands
Spaceport in New Mexico!"</p>
<p class="calibre11">A flash and a thundering boom shattered the air and a sonorous voice
announced: "X Minus Thirty Minutes!"</p>
<p class="calibre11">White Sands Spaceport was a broad flatland, ringed by thousands of
people. In the middle stood a three-stage rocket, waiting; its distance
making it look like a small model. In the foreground was a small
reviewing stand, and on the stand stood Dusty Britton, resplendent in
his Space Patrol uniform. He was extending a hand towards a youngster
about twelve, dressed in a miniature Space Patrol uniform, complete
with a miniature edition of the famous "Dusty Britton" blaster at his
hip.</p>
<p class="calibre11">The lad saluted Dusty; Dusty saluted back.</p>
<p class="calibre11">Then from his shirt pocket Dusty took a small box and an engraved piece
of paper.</p>
<p class="calibre11">"Junior Spaceman Harold Dawson, it is my pleasure to award you this
Medal of Spaceman's Honor.</p>
<p class="calibre11">"I am informed that upon July Seventeen, at Thirteen Hundred Hours
local time, you, Harold Dawson, Spaceman (Jg) full aware of the dangers
that threatened, did without thought of your personal safety, wade deep
into the shifting sands of Mudlark Lake and from that deadly quicksand
return your smaller sister to safety. For valor and for gallantry, I
present you with the Order of The Golden Heart!"</p>
<p class="calibre11">With a flourish, Dusty pinned the decoration on the proud youngster's
chest. The medal glittered there, a small heart of gold surrounded by
rings like those of Saturn, carved in flat relief.</p>
<p class="calibre11">Then with another exchange of salutes, Dusty Britton went down the
steps and into a waiting spaceport jeep and while the crowd cheered
wildly, Dusty was driven across the sands to the spacecraft.</p>
<p class="calibre11">With tolerant parents permitting their young to watch this live,
in-person show no matter what time it was across the earth, it is not
hard to believe that during these many minutes there were more people
thinking about Dusty Britton than there had ever been people thinking
about any other person at any one time in the course of history.</p>
<p class="calibre11">And so Scyth Radnor, tinkering with his menslator on Mercury, trying
to tune it to some response that would deliver definitive thought,
caught much more than he anticipated. In fact, it nearly overloaded the
device.</p>
<p class="calibre11">"Any doubt?" he asked with a twisted smile.</p>
<p class="calibre11">"Nope," from Bren.</p>
<p class="calibre11">"I pass," added Chat.</p>
<p class="calibre11">Scyth said, "So instead of being an uninhabited planet, we have a
rather high culture, complete with space travel. This Dusty Britton
must be quite a hero. But how in the name of the Great Space can
they have space travel without machinus fields or some knowledge of
phanoband radiation?"</p>
<p class="calibre11">"Maybe their space travel is—er—"</p>
<p class="calibre11">"Now look, you're not suggesting that people with a Space Patrol are
riding ships with tailburners? Rockets? What a horrible thought."</p>
<p class="calibre11">Bren shook his head. "Our forefathers lived through it."</p>
<p class="calibre11">"Not many of them," grunted Scyth.</p>
<p class="calibre11">Chat objected. "Read that history you dislike so much. You'll find that
our ancestors went through hundreds of years wallowing across space to
the planets in reaction-type spacecraft. Chemico-atomic rockets, if you
please."</p>
<p class="calibre11">"Let's stop the argument and get along with the main problem," said
Bren. "What are we going to do about them?"</p>
<p class="calibre11">"Well, we can't set up a beacon with them here. So we'll just have to
take the proper measures."</p>
<p class="calibre11">"That'll be quite a project. Whole colonies and—"</p>
<p class="calibre11">"That they haven't got yet. They're at the outpost stage; the
scientific expedition stage. Their moon has less than a hundred people
on it, their Mars has been visited only three times, and their Venus
only once previously. This project that Dusty Britton is going on
is the second Venus rocket, the first one being sent as an orbital,
round-trip manned-job for observational purposes. So we can set up our
barytrine field without causing a lot of distress, and then we can go
on preparing our space beacon."</p>
<p class="calibre11">Bren nodded and Chat said, "You're the handiest man with menslators and
the like, Scyth. You're also the guy that can think fast on his feet.
We elect you to go to the Earth and contact this Dusty Britton and
explain to him so that he can tell his people what is going on."</p>
<p class="calibre11">Bren nodded. "Take the ship and go, Scyth. But use the driver as little
as possible. We'd still like to keep this rift secret, you know. We're
working for Transgalactic, not the whole damned shipping business."</p>
<p class="calibre11">Not long after, on its secondary drivers which did not radiate enough
to make direction-finding much better than haphazard, the spacecraft
rose from Mercury and headed toward Earth.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?081d9a96